import envConst from './env-const'
import createIframeRoute from './views/iframeview'

export default ({ store, app, exclude }) => {
    // 获取用户信息
    const getUserInfo = new Promise((resolve, reject) => {
            app.$http.get('/sctm/user/getLoginUser').then(({ data }) => {
                store.commit('main/user/setUserInfo', data.bean)
                resolve()
            })
        })
        // 获取租户信息
    const getTenantInfo = new Promise((resolve, reject) => {
            app.$http.get(`/sctm/sctmtenantinfos/getByPrimaryKey`).then(({ data }) => {
                window.localStorage.setItem('brandLevel', data.bean.brandLevel)
                let satisfyData = {
                    satisfyState: data.bean.satisfyState,
                    callDirection: data.bean.callDirection,
                    satisfyLevel: data.bean.satisfyLevel,
                    transferCode: data.bean.transferCode,
                };
                let ivrConfirmData = {
                    ivrConfirmState: data.bean.ivrConfirmState,
                    ivrTransferCode: data.bean.ivrTransferCode
                };
                let desensitization = data.bean.masking;
                let reprocessingTime = data.bean.reprocessingTime;
                let videoControlState = data.bean.videoControlState;
                let certificationState = data.bean.certificationState;
                let digitalMan = data.bean.digitalMan;
                let callRepeatState = data.bean.callRepeatState;
                window.localStorage.setItem('satisfyData', JSON.stringify(satisfyData))
                window.localStorage.setItem('ivrConfirmData', JSON.stringify(ivrConfirmData))
                window.localStorage.setItem('desensitization', desensitization)
                window.localStorage.setItem('reprocessingTime', reprocessingTime)
                window.localStorage.setItem('videoControlState', videoControlState)
                window.localStorage.setItem('certificationState', certificationState)
                window.localStorage.setItem('digitalMan', digitalMan)
                window.localStorage.setItem('scocmHiddenFlag', callRepeatState) //外拨强制去重开关
                store.commit('main/setTenant', data.bean)
                resolve()
            })
        })
        // 获取用户权限标签
    const getUserPermissionTag = new Promise((resolve, reject) => {
            app.$http.get('/sctm/userprivilages/getUserMenuPermissionTag').then(res => {
                store.commit('main/user/setUserPermissionTags', res.data.beans)
                resolve()
            })
        })
        // 获取用户角色
    const getUserRole = new Promise((resolve, reject) => {
            app.$http.get('/sctm/userprivilages/userrole').then(res => {
                store.commit('main/user/setUserRoles', res.data.beans)
                resolve()
            })
        })
        // 获取自定义菜单
    const getCustomObjectMenus = new Promise((resolve, reject) => {
            app.$http.get('/sctm/userprivilages/getUserCustomMenu').then(res => {
                store.commit('main/menus/setSelectedMenus', res.data.beans)
                let menus = res.data.beans
                let iframeRoutes = []
                for(let i in menus){
                    dg(menus[i])
                }
                app.$addRoutes(iframeRoutes)
                function dg(menuItem){
                    if(menuItem.menuUrl&&menuItem.menuUrl.indexOf('http')>-1){
                        iframeRoutes.push(createIframeRoute({
                            name: menuItem.name,
                            path: menuItem.path,
                            linkUrl: menuItem.menuUrl,
                            title: menuItem.title
                        },app))
                    }
                    if(menuItem.children&&menuItem.children.length){
                        for(let i in menuItem.children){
                            dg(menuItem.children[i])
                        }
                    }
                }
                app.$addRoutes([
                    createIframeRoute({
                        name: 'testframe',
                        path: '/testframe',
                        linkUrl: 'https://sczd.pointlinkprox.com/test.html',
                        title: '测试iframe'
                    },app),
                    createIframeRoute({
                        name: 'testframe1',
                        path: '/testframe1',
                        linkUrl: '/test.html',
                        title: '测试iframe1'
                    },app)
                ])
                resolve()
            })
        })
        // 获取用户拥有的模块
    const getUserModules = excludeModuleName => {
        return new Promise((resolve, reject) => {
            app.$http.get(`/sctm/sctmresources/getResoursByTenantId`).then(res => {
                let modulesMap = {}
                res.data.beans.forEach(item => {
                    if(item.resourceType == '7'){
                        store.commit('main/menus/setStaticIframes',{
                            name: item.resourceCode,
                            linkUrl: item.vueResourcePath
                        })
                        return
                    }else if(item.resourceType == '9'){
                        store.commit('main/menus/setOutScripts',{
                            name: item.resourceCode,
                            linkUrl: item.vueResourcePath
                        })
                        return
                    }
                    var moduleName = `${item.resourceCode}_ui`
                    // console.log(item.vueResourcePath)
                    if ((moduleName !== excludeModuleName) && item.vueResourcePath){
                      var vueResourcePath = item.vueResourcePath
                      var _path = item.vueResourcePath
                      if(vueResourcePath){
                        var vueResourcePathArr = vueResourcePath.split('?')
                        vueResourcePathArr[0]&&(_path = vueResourcePathArr[0])
                        if(_path&&window.CMSC_VERSION&&window.CMSC_VERSION.scmcc_ui){
                          _path = `${_path}?${window.CMSC_VERSION.scmcc_ui}`
                        }
                      }
                      if(_path){
                        modulesMap[moduleName] = `${envConst.MODULE_HOST ||
                          envConst.SCMCC_HOST}${_path}`
                      }
                    }   
                })
                store.commit('main/user/setUserModules', modulesMap)
                console.log('配置模块',store)
                resolve()
                // app.$moduleLoader(['https://ip:8010/conf.js']).then(()=>{
                //   resolve()
                // })
            })
        })
    }

    return Promise.all([
        getUserInfo,
        getUserRole,
        getUserPermissionTag,
        getCustomObjectMenus,
        getUserModules(exclude),
        getTenantInfo
    ])
}